import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IStoreDataV3 } from '@df/catalog/store/store';
import { UiComponent } from '@df/ui/ui.component';
import { LocalStore } from '../../../catalog/store/store.decorator';

@Component({
    selector: 'branch-finder-item',
    templateUrl: 'branch-finder-item.html',
    styleUrls: ['branch-finder-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BranchFinderItemComponent extends UiComponent implements OnInit {
    /**
     * Store
     */
    @Input({
        required: true
    })
    store!: LocalStore<IStoreDataV3>;

    @Input()
    selected?: boolean;

    @Input()
    stockQty?: number;

    @Input()
    distance?: number;

    @Input()
    disabled?: boolean;

    override ngOnChanges(changes: any): void {
        if (changes.selected || changes.disabled) {
            this.storeStatus = this.disabled ? 'disabled' : this.selected ? 'selected' : 'default';
        }
        super.ngOnChanges(changes);
    }

    private _storeStatus: 'default' | 'selected' | 'disabled' = 'default';

    protected get hasQty(): boolean {
        return typeof this.stockQty === 'number';
    }

    protected get hasDistance(): boolean {
        return typeof this.distance === 'number';
    }

    protected get storeStatus(): string {
        return this._storeStatus;
    }

    protected set storeStatus(value: 'default' | 'selected' | 'disabled') {
        this._storeStatus = value;
    }

    protected select(): void {
        this.storeStatus = 'selected';
        this.detectChanges();
    }
}
